import { router } from '@/router';
import { PageEnum } from '@/enums/pageEnum';
import type { SysType } from '#/sys';
import { reportWhilePageUpdate } from './tracker';

export function navigateBack(delta = -1) {
    router.go(delta);
}

export function redirectTo({ name, data, replace = false, hash }: SysType.urlType) {
    reportWhilePageUpdate();
    if (hash) hash = '#' + hash;
    const packet = pack(data);
    if (data) {
        name
            ? router.replace({ name, state: { packet }, replace, hash })
            : router.replace({ state: { packet }, replace, hash });
    } else {
        router.replace({ name, hash });
    }
}

export function navigateTo({ name, data, replace = false, hash }: SysType.urlType) {
    reportWhilePageUpdate();
    if (hash) hash = '#' + hash;
    if (data) {
        const packet = pack(data);
        name
            ? router.push({ name, state: { packet }, replace, hash })
            : router.push({ state: { packet }, replace, hash });
    } else {
        router.push({ name, hash });
    }
}

export function getQuery() {
    return unpack(history.state.packet);
}

export function pack(data) {
    return encodeURIComponent(JSON.stringify(data));
}

export function unpack(string) {
    return string ? JSON.parse(decodeURIComponent(string)) : {};
}

export function updateTitle(pageName: PageEnum, newTitle: string) {
    if (!pageName) {
        return;
    }

    const current = router.getRoutes().find((item) => item.name === pageName)!;
    current.meta.title = newTitle;
}
